import { lazy } from 'react';
import { RouteType } from '@/Routes';

const KeijiIndex = lazy(() => import('@/pages/keijis'));
const KeijiShow = lazy(() => import('@/pages/keijis/[id]'));
const KeijiSearch = lazy(() => import('@/pages/keijis/search'));
const KeijiSearchType = lazy(() => import('@/pages/keijis/search/[type]'));

const ServerKeiji: RouteType[] = [
  { path: '/keijis', component: KeijiIndex, title: '掲示板' },
  { path: '/keijis/:id([0-9]+)', component: KeijiShow },
  { path: '/keijis/search', component: KeijiSearch, title: '掲示板を検索' },
  {
    path: '/keijis/search/:type(area)',
    component: KeijiSearchType,
    title: '掲示板を検索',
  },
].map((route) => {
  return { ...route, requireAuth: true };
});

export default ServerKeiji;
